import { render, staticRenderFns } from "./OrgElementComponentMitglieder.vue?vue&type=template&id=8a2b65be&lang=pug"
import script from "./OrgElementComponentMitglieder.vue?vue&type=script&lang=js"
export * from "./OrgElementComponentMitglieder.vue?vue&type=script&lang=js"
import style0 from "./OrgElementComponentMitglieder.vue?vue&type=style&index=0&id=8a2b65be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports